<p-dialog
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="delete-user-blocked-dialog"
  [header]="'dialogs.blockedTitle' | translate"
>
  <div class="delete-user-blocked__body" *ngIf="content">
    <p class="delete-user-blocked__primary" [innerHTML]="content.primaryHtml"></p>
    <p class="delete-user-blocked__secondary">{{ content.secondaryText }}</p>

    <p class="delete-user-blocked__suspension" *ngIf="alreadySuspended" data-testid="already-suspended">
      {{ 'dialogs.alreadySuspended' | translate }}
    </p>

    <div class="delete-user-blocked__suspension" *ngIf="canSuspend && !alreadySuspended" data-testid="suspend-choice">
      <p class="delete-user-blocked__secondary">{{ 'dialogs.suspendIntro' | translate }}</p>
      <fieldset class="delete-user-blocked__reasons">
        <legend>{{ 'dialogs.suspendReasonLabel' | translate }}</legend>
        <label *ngFor="let choice of reasons" class="delete-user-blocked__reason">
          <input
            type="radio"
            name="suspension-reason"
            [value]="choice"
            [checked]="reason === choice"
            (change)="chooseReason(choice)"
          />
          {{ reasonChoiceKey(choice) | translate }}
        </label>
      </fieldset>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button type="button" class="delete-user-blocked__close" (click)="onClose()">
      {{ 'dialogs.close' | translate }}
    </button>
    <button
      *ngIf="canSuspend && !alreadySuspended"
      type="button"
      class="delete-user-blocked__suspend"
      data-testid="suspend-button"
      [disabled]="!reason || suspending"
      (click)="suspend()"
    >
      {{ 'dialogs.suspendBtn' | translate }}
    </button>
  </ng-template>
</p-dialog>
